import FakeStreamFactory from "./FakeStreamFactory";
import CanvasStreamProxy from "./CanvasStreamProxy";

class CustomMediaRecorder {

    constructor(stream, durationMillis) {
        console.log("CustomMediaRecorder instantiated with durationMillis: " + durationMillis);
        this.fakeStreamFactory = new FakeStreamFactory();
        this.canvasStreamProxy = new CanvasStreamProxy();
        this.mediaRecorder = null;
        this.targetStream = null;
        this.ondataavailable = null;
        this.onstop = null;
        this.durationMillis = durationMillis; // Default to 10 seconds
        this.inputStream = stream;
    };

    async CreateTargetStream(stream) {
        stream = stream || new MediaStream();

        if (!(stream instanceof MediaStream)) {
            return Promise.reject(new Error('Invalid arugment'));
        }

        if (!stream.getTracks().filter((track) => {
            return track.kind === 'video';
        }).length) {
            const option = {
                videoType: 'black'
            };
            const fakeVideoTrack = this.fakeStreamFactory?.getFakeVideoTrack(option);
            stream.addTrack(fakeVideoTrack);
        }

        const videoTrack = this.canvasStreamProxy?.createCanvasStream(stream);
        const audioTrack = stream.getAudioTracks()[0];

        const resultStream = new MediaStream();
        resultStream.addTrack(videoTrack);
        resultStream.addTrack(audioTrack);

        return Promise.resolve(resultStream);
    }

    replaceVideoTrack = (track) => {
        console.log("REPLACE VIDEO TRACK FUNCTION")
        if (!(track instanceof MediaStreamTrack)) {
            console.error('Track must be an instance of MediaStreamTrack');
            return;
        }

        if (track.kind === 'video') {
            console.log("REPLACING VIDEO TRACK")
            const stream = new MediaStream();
            stream.addTrack(track);
            this.canvasStreamProxy?.replaceVideoStream(stream);
        }
    }

    stop() {
        this.mediaRecorder.stop();
    }

    requestData() {
        if (this.mediaRecorder && this.mediaRecorder.state === 'recording') {
            this.mediaRecorder.requestData();
        } else {
            console.error('MediaRecorder is not recording');
        }
    }

    destroy() {
        if (this.mediaRecorder) {
            this.mediaRecorder.ondataavailable = null;
            this.mediaRecorder.onstop = null;
            this.mediaRecorder = null;
        }
    }

    async start(isHDQuality, is4KQuality=false) {
        let mimeType = '';

        if (MediaRecorder.isTypeSupported('video/webm;codecs=vp9')) {
            mimeType = 'video/webm;codecs=vp9';
        } else if (MediaRecorder.isTypeSupported('video/webm;codecs=vp8')) {
            mimeType = 'video/webm;codecs=vp8';
        } else {
            console.error("No supported video codec found for MediaRecorder.");
            return Promise.reject('No supported codec');
        }

        let videoBitsPerSecond = 5000000; // Default SD (720p)
        if (isHDQuality) {
            videoBitsPerSecond = 12000000;
        }
        if (is4KQuality) {
            videoBitsPerSecond = 20000000;
        }

        const recordingOptions = {
            audioBitsPerSecond: 128000,
            videoBitsPerSecond,
            mimeType
        };

        try {
            this.targetStream = await this.CreateTargetStream(this.inputStream);
        } catch (error) {
            console.error(error);
            return Promise.reject('TargetStream Error');
        }

        try {
            this.mediaRecorder = new MediaRecorder(this.targetStream, recordingOptions);
        } catch (error) {
            console.error(error);
            return Promise.reject('MediaRecorder Error');
        }

        this.mediaRecorder.onstop = this.onstop;
        this.mediaRecorder.ondataavailable = this.ondataavailable;
        this.mediaRecorder.start(this.durationMillis); // 10s chunks
    }
}

export default CustomMediaRecorder;
